export const CREATE_ITEM  = 'CREATE_ITEM';
export const GET_ITEM  = 'GET_ITEM';
export const ITEM_REQUEST  = 'ITEM_REQUEST';
export const DELETE_ITEM  = 'DELETE_ITEM';
export const UPDATE_ITEM  = 'UPDATE_ITEM';
export const ITEM_REQUEST_FAILURE  = 'ITEM_REQUEST_FAILURE';
export const GET_ITEMS_PAGE  = 'GET_ITEMS_PAGE';
export const ITEM_REQUEST_SUCCESS  = 'ITEM_REQUEST_SUCCESS';
export const UPDATE_ITEM_IN_LIST = 'UPDATE_ITEM_IN_LIST';
export const ADD_ITEM_IN_LIST = 'ADD_ITEM_IN_LIST';
export const DELETE_ITEM_IN_LIST = 'DELETE_ITEM_IN_LIST';